import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getProducts = (params = {}) =>
  api.get("/products", { params }).then((r) => r.data);

export const getProductsMeta = () => api.get("/products/meta").then((r) => r.data);

export const getSupportCategories = () =>
  api.get("/support/categories").then((r) => r.data.categories);

export const submitSupport = (payload) =>
  api.post("/support", payload).then((r) => r.data);

export const adminLogin = (token) =>
  api.post("/admin/login", { token }).then((r) => r.data);

export const getSubmissions = (token) =>
  api.get("/admin/submissions", { headers: { "x-admin-token": token } }).then((r) => r.data);

export const getAdminStats = (token) =>
  api.get("/admin/stats", { headers: { "x-admin-token": token } }).then((r) => r.data);

export const updateSubmissionStatus = (id, status, token) =>
  api
    .patch(`/admin/submissions/${id}`, { status }, { headers: { "x-admin-token": token } })
    .then((r) => r.data);
